import React, { useEffect, useMemo, useState } from 'react';
import { Upload } from 'antd';
import ImgCrop from 'antd-img-crop';
import useEventListener from 'hooks/handlePasteFiles';
import { useI18n } from 'hooks/useI18n';

const FileUpload = (props) => {
	useEventListener('paste', (e) => {
		if (e.clipboardData.files.length > 0) {
			const files = Array.from(e.clipboardData.files);
			props.beforeUpload && props.beforeUpload(files[0]);
		}
	});

	const fileList1 = useMemo(() => (props.fileList ? props.fileList : []), [props.fileList]);
	const [fileList, setFileList] = useState(fileList1);

	const { t } = useI18n();

	const onChange = ({ fileList: newFileList }) => {
		console.log('FileUpload onChange called:', newFileList);
		setFileList(newFileList);
		props.setFileList && props.setFileList(newFileList);
		props.onChange && props.onChange({ fileList: newFileList });
		props.afterUpload && props.afterUpload(newFileList);
	};

	useEffect(() => {
		setFileList(fileList1);
	}, [fileList1]);

	const onPreview = async (file) => {
		let src = file.url;
		if (!src) {
			src = await new Promise((resolve) => {
				const reader = new FileReader();
				reader.readAsDataURL(file.originFileObj);
				reader.onload = () => resolve(reader.result);
			});
		}
		const image = new Image();
		image.src = src;
		const imgWindow = window.open(src);
		imgWindow.document.write(image.outerHTML);
	};

	const beforeUpload = (file) => {
		console.log('FileUpload beforeUpload called with:', file);
		
		const isValidType = ['image/jpeg', 'image/png', 'image/jpg', 'image/gif', 'image/webp'].includes(file.type);
		if (!isValidType) {
			props.onError && props.onError('You can only upload image files (JPG, PNG, GIF, WebP)!');
			return Upload.LIST_IGNORE;
		}

		// File size validation
		if (file.size / 1024 / 1024 > 5) {
			props.onError && props.onError('Image must be smaller than 5MB!');
			return Upload.LIST_IGNORE;
		}

		console.log('File validation passed, creating file object...');
		
		// Don't manually create file object here, let Ant Design handle it
		// The ImgCrop component will handle the cropping and call onChange
		
		// Return false to prevent automatic upload, but allow the file to be processed
		return false;
	};

	return (
		<ImgCrop
			aspect={props.freeCrop ? undefined : props.aspect || 1} // Allow free cropping if freeCrop is true
			rotationSlider
			quality={1} // Set quality to maximum for cropped images
			showGrid
			showReset
			beforeCrop={props.freeCrop ? () => false : props.beforeCrop}
			onModalOk={(file) => {
				console.log('ImgCrop onModalOk called with file:', file);
			}}
		>
			<Upload
				action={props.action || undefined}
				listType={props.listType || 'picture-card'}
				fileList={fileList}
				className={props.className}
				onChange={onChange}
				beforeUpload={beforeUpload}
				onPreview={onPreview}
				showUploadList={props.showUploadList !== false}
				accept={props.accept || "image/*"}
				customRequest={props.action === '/' ? ({ file, onSuccess, onError, onProgress }) => {
					console.log('Custom request called with file:', file);
					// Mock successful upload for manual handling
					setTimeout(() => {
						onSuccess("ok");
					}, 0);
				} : undefined}
			>
				{fileList.length < (props.max || 1) && (
					<div className="upload-content">
						{props.uploadText || `+ ${t('ui.actions.upload')}`}
					</div>
				)}
			</Upload>
		</ImgCrop>
	);
};

export default FileUpload;
